<template>
  <div id="choose-treat-container" :class="{ 'smaller-margins': cartSummaryInPdaDesktop }">
    <div id="choose-treat-internal-container">
      <h5
        :class="{ 'smaller-fonts': (cartSummaryInPdaDesktop && $screen.width < 1397)}"
        id="treat-title"
      >
        <font-awesome-icon
          style="margin-right: 4px; margin-bottom:1px; color: #6f2c91"
          icon="gift"
        />Να κεραστεί η παραγγελία;
      </h5>
      <div id="treat-options">
        <div class="treat-option" @click="selectTreat(false)" style="margin-right: 20px;">
          <input
            class="input"
            type="radio"
            :value="false"
            v-model="willTreatProducts"
            @change="onselectTreat"
          />
          <h6
            class="treat-option-title"
            :class="{ selectedBolder: !willTreatProducts,'smaller-fonts': (cartSummaryInPdaDesktop && $screen.width < 1397) }"
          >Όχι</h6>
        </div>
        <div class="treat-option" @click="selectTreat(true)">
          <input
            class="input"
            type="radio"
            :value="true"
            v-model="willTreatProducts"
            @change="onselectTreat"
          />
          <h6
            class="treat-option-title"
            :class="{ selectedBolder: willTreatProducts, 'smaller-fonts': (cartSummaryInPdaDesktop && $screen.width < 1397)}"
          >Ναι</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ChooseTreatOrNot",

  props: ["cartSummaryInPdaDesktop"],
  components: {

  },
  data() {
    return {
      willTreatProducts: false
    }
  },
  watch: {

  },
  computed: {
    language() {
      return this.$store.getters.getLanguage;
    },

  },
  methods: {
    selectTreat(willTreatProducts) {
      this.willTreatProducts = willTreatProducts;
      this.$emit("change-treat-or-not", this.willTreatProducts)
    },
    onselectTreat() {
      this.$emit("change-treat-or-not", this.willTreatProducts)
    }
  },
  mounted() {

  }
};
</script>

<style scoped>
#choose-treat-container {
  width: 90%;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-bottom: 1vh;
  border-bottom: 1px solid rgba(116, 135, 150, 0.2);
  padding: 7.5px 0 7.5px 0;
  color: black;
}

.smaller-margins {
  margin-bottom: 0px !important;
  padding: 2px 0 1px 0 !important;
}

.selectedBolder {
  color: black;
  font-weight: 600;
}

#treat-title {
  font-weight: 600;
  font-size: 14px;
}

#choose-treat-internal-container {
  display: flex;
  flex-direction: column;
}

#treat-options {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.treat-option {
  display: flex;
  flex-direction: row;
  color: #6d6d6d;
  cursor: pointer;
}

.treat-option-title {
  font-size: 14px;
}

.input {
  accent-color: #198b4a;
  margin-bottom: 6px;
  margin-right: 5px;
}

.smaller-fonts {
  font-size: 12px !important;
  font-weight: 500 !important;
}
</style>